import React, { useEffect, useState } from 'react';
import { apiHolder, apis } from 'api';
import IconCard from '@web-common/components/UI/IconCard/index';
import debounce from 'lodash/debounce';
import { MailActions } from '@web-common/state/reducer';
import { useActions } from '@web-common/state/createStore';
import style from './discussIntro.module.scss';
import { getIn18Text } from 'api';
const trackApi = apiHolder.api.requireLogicalApi(apis.dataTrackerApiImp);
const DiscussIntro = props => {
    const { hideBtn = false, close, mailMid = '' } = props;
    const [contHeight, setContHeight] = useState(0);
    const mailActions = useActions(MailActions);
    const closeSelf = () => close && close();
    const toStartDiscuss = () => {
        trackApi.track('pcmail_click_mailDetail_mailChatList_mailChatIntroduce_addNewMailChat', {});
        closeSelf();
        mailActions.doUpdateShareMailMid(mailMid);
    };
    const calcH = () => {
        var _a;
        const ch = (_a = document.querySelector('.discuss-intro-wrap')) === null || _a === void 0 ? void 0 : _a.clientHeight;
        if (ch) {
            const contH = ch - 64 * 2 - 64 - (hideBtn ? 64 : 0);
            setContHeight(contH);
        }
    };
    const handleResize = debounce(() => calcH(), 500);
    useEffect(() => {
        calcH();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    return (React.createElement("div", { className: style.discussIntro, style: { visibility: contHeight > 0 ? 'visible' : 'hidden' } },
        React.createElement("div", { className: style.header },
            getIn18Text('SHENMESHIYOUJIAN'),
            React.createElement("div", { className: style.closeButt, onClick: closeSelf },
                React.createElement(IconCard, { type: "close" }))),
        React.createElement("div", { className: style.content, style: { height: contHeight + 'px' } },
            React.createElement("img", { className: style.part0, src: "https://cowork-storage-public-cdn.lx.netease.com/lxbg/2022/04/21/80bb6f8109464c79bf8e185881f225b5.jpg", alt: getIn18Text('YOUJIANTAOLUN') }),
            React.createElement("div", { className: style.part1 },
                React.createElement("div", { className: style.brightPoint },
                    React.createElement("img", { className: style.brightPointNum, src: "https://cowork-storage-public-cdn.lx.netease.com/lxbg/2022/04/21/e4452f0d4f21420ba4e02ea9e8edd50d.png", alt: getIn18Text('LIANGDIAN1') }),
                    React.createElement("p", { className: style.boldIntro },
                        getIn18Text('ZHENDUIYOUJIANFA'),
                        React.createElement("br", null),
                        getIn18Text('JIAQIYOUJIANGOU')),
                    React.createElement("p", { className: style.intro }, getIn18Text('ZAIYOUXIANGMOKUAI'))),
                React.createElement("img", { className: style.animation, src: "https://cowork-storage-public-cdn.lx.netease.com/lxbg/2022/04/25/480ac4a1a5534ed9bdd55ef7df5106f5.gif", alt: "" })),
            React.createElement("div", { className: style.part2 },
                React.createElement("p", { className: style.part2Intro }, getIn18Text('DANGFAQIYOUJIAN')),
                React.createElement("div", { className: style.mods },
                    React.createElement("img", { className: style.mailMod, src: "https://cowork-storage-public-cdn.lx.netease.com/lxbg/2022/05/24/5721cbced89742368ac5588b0112d63c.png", alt: getIn18Text('YOUJIANMOKUAI') }),
                    React.createElement("img", { className: style.msgMod, src: "https://cowork-storage-public-cdn.lx.netease.com/lxbg/2022/04/21/25517fe44c2449d3b6649e0328b051fd.jpg", alt: getIn18Text('XIAOXIMOKUAI') }))),
            React.createElement("div", { className: style.part3 },
                React.createElement("div", { className: style.brightPoint },
                    React.createElement("img", { className: style.brightPointNum, src: "https://cowork-storage-public-cdn.lx.netease.com/lxbg/2022/04/21/e747af66bc3044fb83dec788aa0db882.png", alt: getIn18Text('LIANGDIAN2') }),
                    React.createElement("p", { className: style.boldIntro },
                        getIn18Text('TAOLUNZUNEIJU'),
                        React.createElement("br", null),
                        getIn18Text('JISHIGOUTONGYU')),
                    React.createElement("p", { className: style.intro }, getIn18Text('ZAIXIAOXIMOKUAI'))),
                React.createElement("img", { className: style.introPic, src: "https://cowork-storage-public-cdn.lx.netease.com/lxbg/2022/05/24/905c770804ce41b39ce89ad1f0d255a7.png", alt: "" }))),
        hideBtn ? null : (React.createElement("div", { className: style.footer },
            React.createElement("button", { className: style.startDiscuss, onClick: toStartDiscuss }, getIn18Text('QUFAQIYOUJIAN'))))));
};
export default DiscussIntro;
